import { useState, useEffect } from 'react'
import { ProjectTypes } from 'models'

export const getPosterGalleryTitle = (type: ProjectTypes) => {
  switch (type) {
    case ProjectTypes.MOVIE: return 'Movie poster'
    case ProjectTypes.TV_SERIES: return 'Series poster'
    case ProjectTypes.TV_SEASON: return 'Season poster'
    case ProjectTypes.TV_EPISODE: return 'Episode poster'
    case ProjectTypes.VOV: return 'VoV poster'
    default: return 'Poster'
  }
}

const initBeforeUnLoad = (showExitPrompt: boolean) => {
  window.onbeforeunload = (event: BeforeUnloadEvent) => {
    if (showExitPrompt) {
      const e = event || window.event
      e.preventDefault()
      if (e) {
        e.returnValue = ''
      }
      return ''
    }
  }
}

// Hook
export const useExitPrompt = (bool: boolean): React.Dispatch<React.SetStateAction<boolean>> => {
  const [showExitPrompt, setShowExitPrompt] = useState<boolean>(bool)

  useEffect(() => {
    initBeforeUnLoad(showExitPrompt)
  }, [showExitPrompt])

  return setShowExitPrompt
}
